export const REACTION_NAMES = ["like", "love", "haha", "wow", "sad", "angry"] as const;

export type ReactionName = (typeof REACTION_NAMES)[number];

export const REACTION_EMOJI: Record<ReactionName, string> = {
  like: "👍",
  love: "❤️",
  haha: "😂",
  wow: "😮",
  sad: "😢",
  angry: "😡",
};

/** Translate a stored reaction name (e.g. "love") to its display emoji ("❤️"). */
export const reactionEmoji = (name: string): string =>
  (REACTION_EMOJI as Record<string, string>)[name] ?? "👍";
